import { render, staticRenderFns } from "./LeaseRegistrationSignatures.vue?vue&type=template&id=28c15ce2"
import script from "./LeaseRegistrationSignatures.vue?vue&type=script&lang=ts"
export * from "./LeaseRegistrationSignatures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports